import { db } from "../firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";

export const saveProgress = async (userId, challengeId, progress) => {
  const ref = doc(db, "users", userId, "progress", String(challengeId));
  await setDoc(ref, progress);
};

export const getProgress = async (userId, challengeId) => {
  const ref = doc(db, "users", userId, "progress", String(challengeId));
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
};
